var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex w-100 align-items-center",
          class: {
            "justify-content-center": _vm.align === "center",
            "justify-content-start": _vm.align === "left",
          },
        },
        [
          _c("div", { staticClass: "p-1 d-flex align-items-center" }, [
            _c("input", {
              ref: "field",
              staticClass: "vuetiful-input",
              class: { "vuetiful-input-error": _vm.hasError },
              attrs: {
                id: _vm.fieldId,
                name: _vm.name,
                type: "checkbox",
                disabled: _vm.disabled,
              },
              domProps: { checked: _vm.fieldValue },
              on: {
                input: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.updateValue.apply(null, arguments)
                },
                focus: _vm.onFocus,
                blur: _vm.onBlur,
              },
            }),
          ]),
          _vm._v(" "),
          _vm.hasLabelSlot || _vm.label
            ? [
                _c(
                  "label",
                  {
                    staticClass:
                      "mt-0 mb-0 font-weight-normal vuetiful-label d-flex align-items-center",
                    class: { "text-muted": _vm.disabled },
                    attrs: { for: _vm.fieldId },
                  },
                  [
                    _vm.hasLabelSlot
                      ? _vm._t("default")
                      : [_vm._v(_vm._s(_vm.label))],
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade-grow" } }, [
        _vm.hasError && _vm.currentError
          ? _c(
              "div",
              {
                staticClass:
                  "mt-2 vuetiful-input-error-text d-flex align-items-center",
                class: {
                  "text-center": _vm.align === "center",
                  "text-left": _vm.align === "left",
                },
              },
              [
                _c("i", {
                  staticClass:
                    "fa fa-exclamation-circle m-r-5 p-1 pr-0 p-t-0 p-b-0",
                }),
                _vm._v(" " + _vm._s(_vm.currentError) + "\n        "),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }